import React, { useState } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import history from './../../../Component/ShearCompo/carateBrowserHistory.js';
import { Container, Row } from 'react-bootstrap';
import LockOpenIcon from '@material-ui/icons/LockOpen';

const JwtLogin = () => {
    document.title = "Log In";

    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        email: '',
        password: '',
    })
    const [message, setMessage] = useState('')
    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo }
        temp[name] = value
        setUserInfo(temp)
    }

    const handleFormSubmit = async (event) => {
        setLoading(true)
        try {
            // await login(userInfo.email, userInfo.password)
            history.push('/')
        } catch (e) {
            console.log(e)
            setMessage(e.message)
            setLoading(false)
        }
    }

    return (
        <Container>
            <Row>
                <div className="col-md-4 px-4 d-flex">
                    <img
                        className="w-200"
                        src="https://shopkpr.s3.ap-south-1.amazonaws.com/Website%20images/shopkpr-personal/logo/logo_1.svg"
                        alt=""
                    />
                </div>
                <div className="col-md-6">
                    <h4 className="pb-3">Enter Login Details</h4>
                    <ValidatorForm onSubmit={handleFormSubmit}>
                        <TextValidator
                            className="w-100 mb-3"
                            variant="outlined"
                            size="small"
                            label="Email"
                            onChange={handleChange}
                            type="email"
                            name="email"
                            value={userInfo.email}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                                'this field is required',
                                'email is not valid',
                            ]}
                        />
                        <TextValidator
                            className="w-100 mb-3"
                            label="Password"
                            variant="outlined"
                            size="small"
                            onChange={handleChange}
                            name="password"
                            type="password"
                            value={userInfo.password}
                            validators={['required']}
                            errorMessages={['this field is required']}
                        />
                        {message && (
                            <p className="text-error">{message}</p>
                        )}

                        <div className="flex  items-center">
                            <div className="">
                                <button className="btn btn-success px-5 " disabled={loading} type="submit">
                                    Login {loading && "..."}
                                </button>
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        className="" />
                                )}

                                <span className="mx-2 ml-5">or</span>
                                <Button
                                    className="capitalize "
                                    onClick={() =>
                                        history.push('/session/signup')
                                    }
                                >
                                    <span className="text-primary text-decoration-underline">Sign up</span>
                                </Button>
                            </div>
                        </div>
                        <Button
                            className="text-warning "
                            onClick={() =>
                                history.push('/session/forgot-password')
                            }
                        >
                            <LockOpenIcon />Forgot password?
                        </Button>
                    </ValidatorForm>
                </div>
            </Row>
        </Container>
    )
}

export default JwtLogin
